import { apiGet } from '../client';
import { PnlResponseSchema, type PnlResult } from '../schemas';

/** Owner-only P&L (docs/CONCEPTS.md: Finanzas); `from`/`to` are 'YYYY-MM-DD', max 366 days apart. */
export async function getPnl(from: string, to: string): Promise<PnlResult> {
  const params = new URLSearchParams({ from, to });
  const response = await apiGet(`/v1/business/pnl?${params.toString()}`, PnlResponseSchema);
  return response.data;
}
